var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 4.16675C16.9375 4.16675 10.4167 10.6876 10.4167 18.7501C10.4167 29.6876 25 45.8334 25 45.8334C25 45.8334 39.5833 29.6876 39.5833 18.7501C39.5833 10.6876 33.0625 4.16675 25 4.16675ZM25 23.9584C23.6187 23.9584 22.2939 23.4097 21.3172 22.4329C20.3404 21.4562 19.7917 20.1314 19.7917 18.7501C19.7917 17.3687 20.3404 16.044 21.3172 15.0672C22.2939 14.0905 23.6187 13.5417 25 13.5417C26.3813 13.5417 27.7061 14.0905 28.6828 15.0672C29.6596 16.044 30.2083 17.3687 30.2083 18.7501C30.2083 20.1314 29.6596 21.4562 28.6828 22.4329C27.7061 23.4097 26.3813 23.9584 25 23.9584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fe3737130842e8e2dd2804c7ea16a6fc.svg";
export { ForwardRef as ReactComponent };